import React from 'react';
import { isChunkLoadError, reloadForNewVersion } from '../../Utils/chunkReload';

interface Props { children: React.ReactNode; }
interface State { hasError: boolean; error?: Error; updating?: boolean; }

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    // A newer version was deployed while this tab was open
    if (isChunkLoadError(error) && reloadForNewVersion()) {
      this.setState({ updating: true });
    }
  }

  render() {
    if (this.state.updating) {
      return (
        <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>
          Updating to the latest version…
        </div>
      );
    }
    if (this.state.hasError) {
      const isUpdate = isChunkLoadError(this.state.error);
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <h2>{isUpdate ? 'A new version is available' : 'Something went wrong'}</h2>
          <p style={{ color: '#6b7280' }}>
            {isUpdate ? 'Reload to get the latest version of Napkin Send.' : this.state.error?.message}
          </p>
          <button onClick={() => window.location.reload()} style={{ marginTop: 16, padding: '8px 16px', borderRadius: 8, border: '1px solid #d1d5db', cursor: 'pointer' }}>
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
